import { useAuth } from "./AuthContext";
import { useState, useEffect } from "react";
import { useNavigate, useLocation, Link as RouterLink } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Paper,
  Grid,
  Fade,
  Grow,
  FormControlLabel,
  Switch,
  Stack,
  Link,
} from "@mui/material";
import SoftButton from "components/SoftButton";
import hero from "assets/images/ampro.png";

export default function SignIn() {
  const { login, loading, error } = useAuth();

  const [remember, setRemember] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/dashboard";

  const [show, setShow] = useState(false);

  // Cargar preferencia de "recuérdame" + correo recordado
  useEffect(() => {
    try {
      const remembered = localStorage.getItem("remember_login");
      if (remembered !== null) {
        const r = remembered === "true";
        setRemember(r);
        if (r) {
          const savedEmail = localStorage.getItem("last_email");
          if (savedEmail) setEmail(savedEmail);
        }
      }
    } catch {}
    setShow(true);
  }, []);

  const handleToggleRemember = () => {
    setRemember((prev) => {
      const next = !prev;
      try {
        localStorage.setItem("remember_login", String(next));
        if (!next) localStorage.removeItem("last_email");
      } catch {}
      return next;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password, remember);

      // Guarda/limpia el correo recordado según el toggle
      try {
        if (remember) localStorage.setItem("last_email", email);
        else localStorage.removeItem("last_email");
      } catch {}

      navigate(from, { replace: true });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        bgcolor: "#f8f9fa",
        p: 2,
      }}
    >
      <Stack spacing={1.25} alignItems="center">
        {/* Logo con fade y menos espacio inferior */}
        <Fade in={show} timeout={500}>
          <Box component="img" src={hero} alt="AMPROFON" sx={{ width: 220, mb: 0.75, borderRadius: 2 }} />
        </Fade>

        {/* Tarjeta con entrada suave */}
        <Grow in={show} timeout={500}>
          <Paper sx={{ p: 3, width: "100%", maxWidth: 420 }}>
            <Typography variant="h5" fontWeight={700} gutterBottom>
              MOCE
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={2}>
              Ingresa tus credenciales
            </Typography>

            <Box component="form" onSubmit={handleSubmit} noValidate>
              <TextField
                fullWidth
                type="email"
                label="Correo"
                margin="normal"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
              />

              <TextField
                fullWidth
                type="password"
                label="Contraseña"
                margin="normal"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />

            <Grid container alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
              <Grid item>
                <Stack direction="row" alignItems="center" spacing={1.25}>
                  <Switch checked={remember} onChange={handleToggleRemember} />
                  <Typography variant="caption" color="text.secondary">
                    Recuérdame
                  </Typography>
                </Stack>
              </Grid>

              <Grid item>
                <SoftButton type="submit" variant="gradient" color="dark" disabled={loading}>
                  {loading ? "Entrando..." : "Entrar"}
                </SoftButton>
              </Grid>
            </Grid>

            {/* Enlace “Olvidaste tu contraseña” debajo del grid */}
            <Box mt={1} textAlign="right">
              <Link component={RouterLink} to="/auth/forgot" variant="caption" underline="hover">
                ¿Olvidaste tu contraseña?
              </Link>
            </Box>

              {error && (
                <Typography mt={1} color="error" variant="caption">
                  {error}
                </Typography>
              )}
            </Box>
          </Paper>
        </Grow>
      </Stack>
    </Box>
  );
}
